import moment from "moment";




export default {
    appointmentList: [],
    filteredList: [],
    resource: [],
    // resource: null,
    resourceList: [],
    resourceFilter: [],
    appointmentDetail: {},
    arrayTime: [],
    calendarView: {
        type: "1w",
        start_time: moment().format("YYYY-MM-DD")
    },
    specificDate: null,
    currentId: null,
    appointmentSearchList: []
}
